import { type ReactNode } from 'react';

type BookingDialogBodyProps = {
  children: ReactNode;
};

export const BookingDialogBody = (props: BookingDialogBodyProps) => {
  const { children } = props;

  return (
    <div className="grid min-h-0 flex-1 content-start gap-4 overflow-y-auto px-6 py-4">
      {children}
    </div>
  );
};
